import React from "react";
import OutlinedButton from "../../../components/buttons/OutlinedButton/OutlinedButton";
import { useStyles } from "./globalinfo.styles";
import my_resume from "../../../assets/pdf/CV_Farah_DRIDI_Software_Engineer.pdf";
import TypeWriterComp from "../../../components/TypeWriter/TypeWriter";
import bg from "../../../assets/images/temp/bg_portfolio-rmbg.png";

function Globalinfo() {
  const styles = useStyles();

  const handle_download_cv = () => {
    window.open(my_resume, "_blank");
  };

  const typeswrites = [
    "Full-Stack Engineer",
    "Java, JavaScript, Python Developer",
    "Experienced in Code Quality Assurance",
    "Committed to Continuous Learning",
    "AI Enthusiast",
  ];

  return (
    <section className={styles.main} id="Home">
      <div className="bgimg" style={{ backgroundImage: `url(${bg})` }}>
        <div className="content-padding"></div>
      </div>
      <div>
        <p className="mynameis">Hello!👋 My name is</p>
        <h1 className="name">Farah DRIDI</h1>
        <h1 className="role">
          <TypeWriterComp strings={typeswrites} />
        </h1>
        <p className="description">
          I am a software engineer specializing in creating exceptional digital
          experiences. I am actively seeking new challenges and opportunities that will allow
          me to expand my skills and deepen my knowledge in the field.
        </p>
        <OutlinedButton onClick={handle_download_cv}>My Resume</OutlinedButton>
      </div>
    </section>
  );
}

export default Globalinfo;
